import { useUserStore } from '@/stores/user'
import { usePermissionsStore } from '@/stores/permissions'
import { useAuthProvidersStore } from '@/stores/authProviders'
import { useNotificationStore } from '@/stores/notification'

import UserProfileService from '@services/users/userProfileService';
import authService from '@/services/auth/authService';

import { handleRequest } from '@/utils/handleRequest';


export function useAppInit() {
  const userStore = useUserStore()
  const permissionsStore = usePermissionsStore()

  async function initialize() {
    if (userStore.isLoggedIn && permissionsStore.permissions.length > 0) return

    const authProvidersStore = useAuthProvidersStore();
    await handleRequest(() => authService.fetchProviders(), {
      onSuccess: (providers) => authProvidersStore.setProviders(providers)
    });

    // TODO: error handling
    await handleRequest(() => UserProfileService.me(),
      {
        onSuccess: (user) => {
          userStore.setUser(user.data.user);
          permissionsStore.setPermissions(user.data.permissions);
        },
      }
    );

    if (userStore.isLoggedIn) {
      const notificationStore = useNotificationStore();
      await handleRequest(() => notificationStore.fetchNotifications(), {});
      notificationStore.subscribe();
    }
  }

  function teardown() {
    const notificationStore = useNotificationStore();
    notificationStore.reset();
  }

  return { initialize, teardown }
}
